import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const turnoLaboralImporterSelectors = importerSelectors(
  'turnoLaboral.importer',
);

export default turnoLaboralImporterSelectors;
